const EarlyWarning = [
    {
        path: "/wcp/early/warning/latest",
        name: "LatestWarning",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u6700\u65b0\u9884\u8b66', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-list/latest-warning"),
        }
    },
    {
        path: "/wcp/early/warning/manual",
        name: "ManualWarning",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u4eba\u5de5\u9884\u8b66', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-list/manual-warning"),
        }
    },
    {
        path: "/wcp/early/warning/publish",
        name: "WarningPublish",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u53d1\u5e03\u9884\u8b66', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-list/publish-warning"),
        }
    },
    {
        path: "/wcp/early/warning/record",
        name: "WarningRecord",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u8b66\u67e5\u8be2', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-query/warning-record"),
        }
    },
    {
        path: "/wcp/early/warning/record/publish",
        name: "PublishRecord",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u53d1\u5e03\u8bb0\u5f55', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-query/publish-record")
        }
    },
    {
        path: "/wcp/early/warning/record/publish/detail",
        name: "DetailedRecord",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u8be6\u7ec6\u4fe1\u606f', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-query/publish-record/components/DetailedRecord"),
        }
    },
    {
        path: "/wcp/early/warning/grade",
        name: "Grade",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u8b66\u7b49\u7ea7', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-info/grade/Grade"),
        }
    },
    {
        path: "/wcp/early/warning/grade/modify",
        name: "GradeModify",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u8b66\u7b49\u7ea7', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-info/grade/GradeModify"),
        }
    },
    {
        path: "/wcp/early/warning/type",
        name: "Type",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u8b66\u7c7b\u578b', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-info/type/Type"),
        }
    },
    {
        path: "/wcp/early/warning/type/modify",
        name: "TypeModify",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u8b66\u7c7b\u578b', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-info/type/TypeModify"),
        }
    },
    {
        path: "/wcp/early/warning/rule",
        name: "Rule",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u8b66\u89c4\u5219', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-info/rule/Rule"),
        }
    },
    {
        path: "/wcp/early/warning/rule/modify",
        name: "RuleModify",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u8b66\u89c4\u5219', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-info/rule/RuleModify"),
        }
    },
    {
        path: "/wcp/early/warning/dp",
        name: "Dp",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u8b66\u90e8\u95e8', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-info/dp/Dp"),
        }
    },
    {
        path: "/wcp/early/warning/dp/modify",
        name: "DpModify",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u8b66\u90e8\u95e8', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/warning-info/dp/DpModify"),
        }
    },
    {
        path: "/wcp/early/warning/plan",
        name: "Plan",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u6848\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/plan/Plan"),
        }
    },
    {
        path: "/wcp/early/warning/plan/modify",
        name: "PlanModify",
        meta: { title: '\u9884\u8b66\u7ba1\u7406-\u9884\u6848\u7ba1\u7406', requireAuth: true },
        components: {
            left: () => import("@/views/early-warning/navigation/NavigationBar"),
            main: () => import("@/views/early-warning/plan/PlanModify"),
        }
    }
]

export default EarlyWarning;


// WEBPACK FOOTER //
// ./src/router/early-warning.js